import React from 'react';
import { useGlobalization } from '../../contexts/GlobalizationProvider';
export default function ContactUsMessage() {
    const { t } = useGlobalization();
    return (React.createElement(React.Fragment, null,
        t('Please, contact us via '),
        React.createElement("a", { href: "https://www.autodesk.com/support/contact-support ", target: "_blank", rel: "noopener noreferrer" }, t('the Autodesk support channels')),
        "."));
}
